import Layout from '../containers/Layout';

export const getRoutes = (/* store */) => {
  const errorLoading = (err) => {
    throw new Error('Dynamic page loading failed: ', err);
  };

  const loadRoute = (cb) => {
    return module => cb(null, module.default);
  };

  // const requireAuth = (nextState, replace) => {
  //   const currentState = store.getState();
  //   const { auth } = currentState;
  //   // in the future this will check the token & expiration date of the user
  //   if (!auth.valid) replace({ pathname: '/login' });
  // };

  // const isLogin = (nextState, replace) => {
  //   const currentState = store.getState();
  //   const { auth } = currentState;

  //   if (auth.valid) {
  //     replace({ pathname: '/' });
  //   }
  // };

  return {
    path: '/',
    component: Layout,
    indexRoute: {
      getComponent(location, cb) {
        System.import('../containers/Home/Home')
          .then(loadRoute(cb))
          .catch(errorLoading);
      },
    },
    childRoutes: [
      {
        path: '/apartment/:id/:name',
        getComponent(location, cb) {
          System.import('../containers/ApartmentView/ApartmentView.js')
            .then(loadRoute(cb))
            .catch(errorLoading);
        },
      },
      {
        path: '/payment/add-payment-method',
        getComponent(location, cb) {
          System.import('../containers/Payment/AddPaymentMethod.js')
            .then(loadRoute(cb))
            .catch(errorLoading);
        },
      },
      {
        path: '/user/booking-history',
        getComponent(location, cb) {
          System.import('../containers/BookingHistory/BookingHistory.js')
            .then(loadRoute(cb))
            .catch(errorLoading);
        },
      },
      {
        path: '/profile',
        getComponent(location, cb) {
          System.import('../containers/UserProfile/UserProfile.js')
            .then(loadRoute(cb))
            .catch(errorLoading);
        },
      },
      {
        path: '/:name/:id',
        getComponent(location, cb) {
          System.import('../containers/CityView/CityView.js')
            .then(loadRoute(cb))
            .catch(errorLoading);
        },
      },
      {
        path: '/test',
        getComponent(location, cb) {
          System.import('../components/Test/Test.js')
            .then(loadRoute(cb))
            .catch(errorLoading);
        },
      },
      {
        path: '*',
        getComponent(location, cb) {
          System.import('../components/NotFound/NotFound')
            .then(loadRoute(cb))
            .catch(errorLoading);
        },
      },
    ],
  };
};



// WEBPACK FOOTER //
// ./src/lib/routes.js